// src/routes/FAQ.jsx
import ContentPage from "@/components/content/ContentPage";

const FAQ = () => <ContentPage docKey="faq" />;

export default FAQ;
